module.exports = __webpack_public_path__ + "img/product02.5b80f54b.png";